import { render, staticRenderFns } from "./cas-item.vue?vue&type=template&id=0bc9b2dc&"
import script from "./cas-item.vue?vue&type=script&lang=js&"
export * from "./cas-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc9b2dc')) {
      api.createRecord('0bc9b2dc', component.options)
    } else {
      api.reload('0bc9b2dc', component.options)
    }
    module.hot.accept("./cas-item.vue?vue&type=template&id=0bc9b2dc&", function () {
      api.rerender('0bc9b2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cascader/cas-item.vue"
export default component.exports